import { render, staticRenderFns } from "./FilterCourseLocaiton.vue?vue&type=template&id=07812684&lang=pug"
import script from "./FilterCourseLocaiton.vue?vue&type=script&lang=js"
export * from "./FilterCourseLocaiton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports